import type { NutritionSnapshotRecord } from "../../persistence/records";

export type ImportedFoodBasisUnit = "g" | "ml";

export interface ImportedFoodMeasure {
  id: "serving" | "package";
  label: string;
  /** Number of canonical basis units represented by one measure. */
  amount: number;
}

export interface ImportedFoodDraft {
  provider: "open-food-facts";
  externalId: string;
  sourceUrl: string;
  name: string;
  brand?: string;
  barcode: string;
  basis: { amount: 100; unit: ImportedFoodBasisUnit };
  measures: ImportedFoodMeasure[];
  nutrition: NutritionSnapshotRecord;
  declaredCaloriesPer100g?: number;
  imageUrl?: string;
  missingMacros: Array<"protein" | "carbohydrate" | "fat">;
  macroSuggestion: "provider" | "equal-energy-fallback" | "empty-fallback";
  /** True means the draft cannot become a preferred local food until confirmed. */
  requiresMacroConfirmation: boolean;
}

export interface FoodSearchResult {
  items: ImportedFoodDraft[];
  page: number;
  pageCount?: number;
  totalCount?: number;
}

export class FoodSourceError extends Error {
  constructor(
    message: string,
    readonly kind: "offline" | "rate-limited" | "not-found" | "invalid-response" | "remote-error",
    readonly retryAfterSeconds?: number,
  ) {
    super(message);
    this.name = "FoodSourceError";
  }
}
